<template>
<div class="mgm mgmshare">
    <img style="visibility: hidden;position:absolute;" :src="ilogSrc" />
    <div class="mgm-sg">
        <div class="m-s-1">
            <p @click="inviteHandle" v-if="isInvite">我的邀请</p>
        </div>
        <div class="m-s-2">
            <div @click="shareHandle" class="share-btn" data-ilog="14.1503.vI4"></div>
        </div>
        <div class="m-s-3">
            <div class="share-text">
                <div class="event-header"></div>
                <div class="event-text">
                    <p>1. <b>活动时间：</b></p>
                    <p>2017年即日起-2017年12月21日 23:59分。</p>
                    <p>2. <b>奖品：</b>每成功邀请好友1人即可获得88元点点免息券，上不封顶。</p>
                    <p>3. <b>获奖条件：</b>邀请的好友下载登录点点APP，完成申请并获得授信额度。</p>
                    <p>4. <b>奖品查看：</b>APP首页我的-邀请有奖-我的邀请，可查看邀请好友进度；首页我的-我的优惠券，可查看免息券详细内容。</p>
                    <p>5. <b>奖品使用：</b>点点免息券在提现时可抵用同等金额利息，具体使用方法详见 我的优惠券-免息券使用说明。</p>
                    <p>6. <b>奖品效期：</b>30天，包括领券日当天。超过有效期未使用免息券则自动失效。</p>
                    <p>7. 本次活动最终解释权归众联商务所有。</p>
                </div>
            </div>
        </div>
        <div class="m-s-4"></div>
        <div class="m-s-5"></div>
    </div>
    <div @click="shareMarkHandle" v-if="isShareMark" class="share-mark">
        <div class="sm-icon"></div>
    </div>
</div>
</template>
<style lang="scss">
@import '../assets/styles/all.scss';
b {
    font-weight: bold;

}
.share-mark {
    background: rgba(0,0,0,0.7);
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    .sm-icon {
        position: absolute;
        top: r(40);
        right: r(40);
        width: r(243);
        height: r(96);
        background: url("../assets/images/share-t-icon.png");
        background-size: 100% 100%;
    }
}
.mgmshare {
    background: #6a8cfa;
}
.event-text {
    width: 90%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: r(75) r(18) 0;
    p {
        color: #ffffff;
        font-size: r(12);
        padding-bottom: r(10);
    }
}
#dd-logo {
    position: absolute;
    left: 0;
    top: 0;
    visibility: hidden;
}
.mgm-sg {
    > div {
        width: 100%;
    }
    .m-s-1 {
        position: relative;
        height: r(202);
        background: url("../assets/images/ms-bg-1.jpg");
        background-size: 100% 100%;
        p {
            position: absolute;
            top: r(15);
            right: r(15);
            width: r(72);
            height: r(25);
            text-align: center;
            line-height: r(25);
            background: #4454f3;
            color: #daddfd;
            border-radius: r(20);
            font-size: r(13);
        }
    }
    .m-s-2 {
        height: r(116);
        background: url("../assets/images/ms-bg-2.jpg");
        background-size: 100% 100%;
        .share-btn {
            width: r(288);
            height: r(50);
            margin-top: r(40);
            position: absolute;
            left: 50%;
            -webkit-transform: translateX(-50%);
        }
    }
    .m-s-3 {
        width: 90%;
        margin: 0 auto;
        border-radius: r(10);
        position: relative;
        overflow: hidden;
        // background: url(../assets/images/mgm-bg-3.jpg);
        // background-size:100% 100%;

        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#7249f6+0,7249f6+56,4b5af5+100 */
        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#387cfe+0,6f5fed+100 */
        background: #387cfe;
        /* Old browsers */
        background: -moz-linear-gradient(top, #387cfe 0%, #6f5fed 100%);
        /* FF3.6-15 */
        background: -webkit-linear-gradient(top, #387cfe 0%,#6f5fed 100%);
        /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, #387cfe 0%,#6f5fed 100%);
        /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

        .event-header {
            width: r(157);
            height: r(25);
            position: relative;
            top: r(20);
            left: 50%;
            -webkit-transform: translateX(-50%);
            background: url("../assets/images/s-t-bg.jpg") no-repeat;
            background-size: 100% 100%;
        }

        .event-text {
            width: 90%;
            margin: 0 auto;
            box-sizing: border-box;
            padding: r(25) r(10) r(18);
            p {
                color: #ffffff;
                font-size: r(13);
                padding-bottom: r(10);
                text-align: justify;
                text-justify: inter-ideograph;
            }
        }
    }
    .m-s-4 {
        height: r(180);
        background: url("../assets/images/ms-bg-4.jpg");
        background-size: 100% 100%;
    }
    .m-s-5 {
        height: r(217);
        background: url("../assets/images/ms-bg-5.jpg");
        background-size: 100% 100%;
    }

}
</style>
<script>
import axios from 'axios';
import diandianImg from '../assets/images/dd-logo.png';
import config from '../config'
import {
    randomString
} from '../utils//tool'

import {
    wxAuth
} from '../utils/wxauth'
import {
    share
} from '../utils/wxshare'

export default {
    data() {
        return {
            baseData: '',
            helplist: [],
            isShareMark: false,
            isInvite: false,
            ilogSrc: ''
        }
    },
    components: {

    },
    beforeRouteEnter(to, from, next) {
        document.title = '邀请好友'
        next()
    },
    beforeRouteLeave(to, from, next) {
        next()
    },
    mounted() {
        this.baseData = diandianImg.split(',')[1]
        var u = navigator.userAgent
        //微信
        if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
            this.isInvite = true
            // wxAuth()
            share(this)
        }

    },
    methods: {
        shareMarkHandle() {
            this.isShareMark = false
        },
        inviteHandle() {
            let ago = ''
            switch (config.ENV) {
                case '-test':
                    ago = 'https://one-test.zhongan.com/fcp/diandian-oa/#/invite'
                    break
                case '-uat':
                    // UAT 时候需要修改
                    ago = 'https://one-uat.zhongan.com/fcp/diandian-oa/#/invite'
                    break
                case '':
                    ago = 'https://fin-app.zhongan.com/sh/diandian-oa/#/invite'
                    break
            }
            window.location.href = ago
        },
        shareHandle() {
            var u = navigator.userAgent
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            //微信
            if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
                this.isShareMark = true
                return
            } else {
                this.isShareMark = false
            }

            //分享URL APP调用
            var shareUrl = '';
            switch (config.ENV) {
                case '-test':
                    shareUrl = 'https://one-test.zhongan.com/fcp/diandian/#/mgmindex'
                    break
                case '-uat':
                    shareUrl = 'https://one-uat.zhongan.com/fcp/diandian/#/mgmindex'
                    break
                case '':
                    shareUrl = 'https://fin-app.zhongan.com/sh/diandian/#/mgmindex'
                    break
            }

            if (isAndroid) {
                var sharParam = JSON.stringify({
                    title: '秒拿5万，点一点就有钱',
                    content: '真金白银等你来，5万借款额度秒变高富帅！小伙伴们快来手慢无！',
                    url: shareUrl,
                    imageUrl: 'https://fin-app.zhongan.com/sh/diandian/dd-logo.png',
                    image: this.baseData
                })
                NativeObject.inviteShare(sharParam);
            } else if (isiOS) {
                window.webkit.messageHandlers.InviteShare.postMessage({
                    title: '秒拿5万，点一点就有钱',
                    content: '真金白银等你来，5万借款额度秒变高富帅！小伙伴们快来手慢无！',
                    url: shareUrl,
                    image: this.baseData
                });
            }

        }
    }
}
</script>



// WEBPACK FOOTER //
// mgmshare.vue?bc801e1e